import { Flex, Typography } from "antd";
import { TDetailedStoryboard } from "pages/media/types";
import { ScriptWithHighlights } from "./ScriptWithHighlights";

export const Present = ({
  storyboard,
}: {
  storyboard: TDetailedStoryboard;
}) => {
  return (
    <Flex vertical style={{ paddingTop: 10 }} gap={20}>
      {storyboard.sections.map((section, sectionIndex) => {
        return (
          <Flex key={section.id} vertical>
            <Typography.Title level={4}>{section.topic}</Typography.Title>
            <Typography.Text style={{ fontSize: 18 }}>
              <ScriptWithHighlights
                script={section.script?.content ?? ""}
                contentEditable={false}
                index={sectionIndex}
              />
            </Typography.Text>
          </Flex>
        );
      })}
    </Flex>
  );
};
